import Grid from './grid.tsx';
import Group from '~/services/plugins/group-qb/components/index.tsx';
import Hero from '../services/plugins/hero/components/index.tsx';
import List from './list.tsx';
import HorizontalList from './horizontal-list/index.tsx';
import UserAccount from './user-account.tsx';
import type { UIComponentType } from '~/services/layout/index.ts';
import EPG from './epg/index.tsx';
import GridV2 from '~/services/plugins/grid_v2/components/index.tsx';
import HeroV2 from '~/services/plugins/hero_v2/components/index.tsx';
import HorizontalListV2 from '~/services/plugins/horizontal-list/components/index.tsx';
import WebviewComponent from '~/services/plugins/web-view-component/components/index.tsx';
import PaymentInfo from '~/services/plugins/payment-info/components/index.tsx';
import SubscriptionManagement from '~/services/plugins/subscription-management/components/index.tsx';
import GroupInfoV2 from '~/services/plugins/group_info_v2/components/index.tsx';
import ListV2 from '~/services/plugins/list_v2/components/index.tsx';
import { CustomCopyToClipboard } from '~/services/plugins/custom-copy-to-clipboard/components/index.tsx';

export const UIComponents: Record<
  UIComponentType,
  ((props: any) => JSX.Element) | null
> = {
  // #region Deprecated components
  horizontal_list_qb: HorizontalList,
  'list-qb': List,
  'hero-qb': Hero,
  'grid-qb': Grid,
  // #endregion

  'group-qb': Group,
  group_info_v2: GroupInfoV2,
  horizontal_list_v2: HorizontalListV2,
  grid_v2: GridV2,
  list_v2: ListV2,
  hero_v2: HeroV2,

  'payment-info': PaymentInfo,
  webview_component: WebviewComponent,
  epg_component: EPG,
  'quick-brick-user-account-ui-component': UserAccount,
  'subscription-management': SubscriptionManagement,

  custom_copy_to_clipboard: CustomCopyToClipboard,

  empty_group_v2: null,
  'group-info-qb': null,
  empty_group_component: null,
  'quick-brick-smart-component': null,
};
